/**
 * Development CLOUD: the deployed huddle-sports-development project (demos and
 * shared-state work, NOT the emulator dev loop). `useEmulators: false`, so
 * `src/app/core/firebase.ts` talks straight to the cloud project - the
 * emulator strings stay empty and are never read.
 *
 * Config from the registered huddle-hq web app on huddle-sports-development.
 * The emulator-first default lives in `environment.ts`; production in
 * `environment.prod.ts`. All three share one shape so `core/firebase.ts`
 * type-checks against each.
 */
export const environment = {
  production: false,
  useEmulators: false,
  firebase: {
    projectId: 'huddle-sports-development',
    apiKey: 'AIzaSyDop2l1EC8Zb6tg_WbKWAabn1CkFl_qG-Q',
    appId: '1:771300067120:web:ddef336dec8fbc645f6af5',
    authDomain: 'huddle-sports-development.firebaseapp.com',
    storageBucket: 'huddle-sports-development.firebasestorage.app',
  },
  emulators: {
    firestore: '',
    auth: '',
    functions: '',
    storage: '',
  },
  region: 'europe-west1',
};
